import { APIClient, setAuthorization } from "./api_helper";
import axios from "axios";

const api = new APIClient();

export const postLogin = (data: any) => api.create(`api/users/auth/login`, data);
export const postQRLogin = (data: any) => api.create(`api/users/auth/qr-login`, data);
export const getQRLoginToken = () => api.get(`api/users/qr-login/token`);
export const LogActivity = (data: any) => api.create(`/api/activity/logs`, data);
export const UpdateFCMToken = (id: any, data: any) => api.put(`api/users/fcm-token`, data);
export const ChangePassword = (data: any) => api.put(`/api/users/auth/change-password`, data);
export const SetFirstTimePassword = (data: any) => api.put(`/api/users/auth/set-first-time-password`, data);

export const RestPassword = (data: any) => api.create(`api/users/password-reset/request`, data);
export const VerifyPassword = (data: any) => api.create(`api/users/password-reset/verify`, data);

export const GetDashboardData = () => api.get(`/api/users/get_analytics`);
export const GetEmployeeDashboardData = () => api.get(`/api/users/get_monthly_user_stats`);
export const GetSessionAnalytics = (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    return api.get(`/api/session-analytics/company?${params.toString()}`);
};

// Company
export const GetAllCompanies = () => api.get('/api/company/');
export const GetCompanyByID = (company_id: any) => api.get(`/api/company/${company_id}`);
export const CreateNewCompany = (data: any) => api.create(`/api/company/`, data);
export const UpdateCompany = (id: any, data: any) => api.put(`/api/company/${id}`, data);
export const UploadCompanyLogoSquare = (company_id: any, data: any) => api.create(`/api/company/${company_id}/logo-square`, data);
export const UploadCompanyLogoWide = (company_id: any, data: any) => api.create(`/api/company/${company_id}/logo-wide`, data);

// Tenant Management
export const GetTenantsList = (page?: number, per_page?: number, status?: string) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page.toString());
    if (per_page) params.append('per_page', per_page.toString());
    if (status) params.append('status', status);
    return api.get(`/api/tenants/admin/tenants?${params.toString()}`);
};
export const GetTenantDetails = (tenant_id: any) => api.get(`/api/tenants/admin/tenants/${tenant_id}`);
export const UpdateTenantSubscription = (tenant_id: any, data: any) => api.put(`/api/tenants/admin/tenants/${tenant_id}/subscription`, data);
export const SuspendTenant = (tenant_id: any, data: any) => api.create(`/api/tenants/admin/tenants/${tenant_id}/suspend`, data);
export const UnsuspendTenant = (tenant_id: any) => api.create(`/api/tenants/admin/tenants/${tenant_id}/unsuspend`, {});
export const UpdateTenantFeatures = (tenant_id: any, data: any) => api.put(`/api/tenants/admin/tenants/${tenant_id}/features`, data);
export const UpdateTenantLimits = (tenant_id: any, data: any) => api.put(`/api/tenants/admin/tenants/${tenant_id}/limits`, data);
export const GetTenantAnalytics = (tenant_id: any, days?: number) => {
    const params = new URLSearchParams();
    if (days) params.append('days', days.toString());
    return api.get(`/api/tenants/admin/tenants/${tenant_id}/analytics?${params.toString()}`);
};
export const ExtendTrial = (tenant_id: any, data: any) => api.create(`/api/tenants/admin/tenants/${tenant_id}/extend-trial`, data);
export const RegisterTenant = (data: any) => api.create(`/api/tenants/register`, data);
export const GetTenantInfo = () => api.get(`/api/tenants/info`);
export const GetTenantUsage = () => api.get(`/api/tenants/usage`);
export const GetTenantFeatures = () => api.get(`/api/tenants/features`);

// Department
export const GetAllDepartments = () => api.get('/api/department/');
export const CreateNewDepartment = (data: any) => api.create(`/api/department/`, data);
export const UpdateDepartment = (id: any, data: any) => api.put(`/api/department/${id}`, data);
export const AssignDepartmentHead = (id: any, data: any) => api.put(`/api/department/${id}/update-head`, data);
export const DeleteDepartment = (id: any) => api.delete(`/api/department/${id}`);

// Designation
export const GetAllDesignation = () => api.get('/api/designations/');
export const CreateNewDesignation = (data: any) => api.create(`/api/designations/`, data);
export const UpdateDesignation = (id: any, data: any) => api.put(`/api/designations/${id}`, data);
export const AssignDesignation = (id: any, data: any) => api.put(`/api/designations/${id}/assign-designation`, data);
export const DeleteDesignation = (id: any) => api.delete(`/api/designations/${id}`);

// Role
export const GetAllRole = () => api.get('/api/roles/');
export const CreateNewRole = (data: any) => api.create(`/api/roles/addNew`, data);
export const UpdateRole = (id: any, data: any) => api.put(`/api/roles/${id}`, data);
export const AssignRole = (id: any, data: any) => api.put(`/api/roles/${id}/update-role`, data);
export const DeleteRole = (id: any) => api.delete(`/api/roles/${id}`);

// Resume
export const GetAllResumes = (params?: { page?: number; per_page?: number }) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.per_page) queryParams.append('per_page', params.per_page.toString());
    const queryString = queryParams.toString();
    return api.get(`/api/resumes/${queryString ? `?${queryString}` : ''}`);
};
export const GetResumeByID = (id: any) => api.get(`/api/resumes/${id}`);
export const CreateResume = (data: any) => api.create(`/api/resumes/`, data);
export const UpdateResume = (id: any, data: any) => api.put(`/api/resumes/${id}`, data);
export const UpdateResumeStatus = (id: any, data: any) => api.put(`/api/resumes/${id}/status`, data);
export const ScheduleInterview = (id: any, data: any) => api.create(`/api/resumes/${id}/schedule-interview`, data);
export const DeleteResume = (id: any) => api.delete(`/api/resumes/${id}`);
export const DownloadResume = (id: any) => api.get(`/api/resumes/${id}/download`);
export const ValidateResumeToken = (token: string) => api.create('/api/resumes/validate-token', { token });
export const CheckResumeToken = (token: string) => api.get(`/api/resumes/check-token?token=${token}`);

// Time-based links management
export const GetTimeBasedLinks = () => api.get('/api/resumes/time-based-links/');
export const CreateTimeBasedLink = (data: any) => api.create('/api/resumes/time-based-links', data);
export const UpdateTimeBasedLink = (linkId: number, data: any) => api.put(`/api/resumes/time-based-links/${linkId}`, data);
export const DeleteTimeBasedLink = (linkId: number) => api.delete(`/api/resumes/time-based-links/${linkId}`);
export const UseTimeBasedLink = (token: string) => api.create('/api/resumes/time-based-links/use', { token });
export const UpdateTimeBasedLinkUses = (linkId: number, maxUses: number) => api.create(`/api/resumes/time-based-links/${linkId}/update-uses`, { max_uses: maxUses });

// Interview Links
export const CheckInterviewToken = (token: string) => api.get(`/api/interviews/validate-token?token=${token}`);
export const ValidateInterviewToken = (token: string) => api.create('/api/interviews/validate-token', { token });
export const GetInterviewTokens = () => api.get('/api/interviews/tokens');
export const CreateInterviewToken = (data: any) => api.create('/api/interviews/tokens', data);
export const DeleteInterviewToken = (tokenId: number) => api.delete(`/api/interviews/tokens/${tokenId}`);
export const StartInterviewSession = (token: string, candidateInfo?: any) => api.create('/api/interviews/sessions/start', { token, candidate_info: candidateInfo });
export const UploadInterviewRecording = (sessionId: string, formData: FormData) => api.create(`/api/interviews/sessions/${sessionId}/upload`, formData);
export const EndInterviewSession = (sessionId: string) => api.create(`/api/interviews/sessions/${sessionId}/end`, {});
export const GetInterviewSessions = () => api.get('/api/interviews/sessions');
export const GetInterviewRecording = (sessionId: string) => api.get(`/api/interviews/sessions/${sessionId}/recording`);
export const GetInterviewRecordingFile = (filepath: string) => `/api/interviews/recordings/${filepath}`;

// Employee Onboarding Links
export const GenerateEmployeeOnboardingLink = (employeeId: string, data?: any) => 
  api.create(`/api/users/${employeeId}/generate-onboarding-link`, data || {});
export const GetEmployeeOnboardingLinks = (employeeId: string) => 
  api.get(`/api/users/${employeeId}/onboarding-links`);
export const RevokeEmployeeOnboardingLink = (employeeId: string, linkId: number) => 
  api.delete(`/api/users/${employeeId}/onboarding-links/${linkId}`);
export const ValidateEmployeeOnboardingToken = (token: string) => 
  api.get(`/api/public/employee-onboarding/validate-token?token=${token}`);
export const CompleteEmployeeOnboarding = (data: FormData) => 
  api.create('/api/public/employee-onboarding/complete', data);

// Resume parsing
export const ParseResume = (resumeId: string) => api.create(`/api/resumes/${resumeId}/parse`, {});
export const GetParsedResumeData = (resumeId: string) => api.get(`/api/resumes/${resumeId}/parsed-data`);

// Bulk operations
export const BulkUpdateResumeStatus = (data: any) => api.create('/api/resumes/bulk/update-status', data);
export const BulkSendEmails = (data: any) => api.create('/api/resumes/bulk/send-emails', data);

// Resume Rating
export const RateResume = (resumeId: any, data: any) => api.create(`/api/resumes/${resumeId}/rate`, data);
export const GetResumeRating = (resumeId: any) => api.get(`/api/resumes/${resumeId}/rating`);

// Resume Comments/Collaboration
export const AddResumeComment = (resumeId: any, data: any) => api.create(`/api/resumes/${resumeId}/comments`, data);
export const GetResumeComments = (resumeId: any) => api.get(`/api/resumes/${resumeId}/comments`);
export const UpdateResumeComment = (resumeId: any, commentId: any, data: any) => api.put(`/api/resumes/${resumeId}/comments/${commentId}`, data);
export const DeleteResumeComment = (resumeId: any, commentId: any) => api.delete(`/api/resumes/${resumeId}/comments/${commentId}`);

// Resume Tags
export const AddResumeTag = (resumeId: any, data: any) => api.create(`/api/resumes/${resumeId}/tags`, data);
export const GetResumeTags = (resumeId: any) => api.get(`/api/resumes/${resumeId}/tags`);
export const RemoveResumeTag = (resumeId: any, tagId: any) => api.delete(`/api/resumes/${resumeId}/tags/${tagId}`);
export const GetAllTags = () => api.get('/api/resumes/tags');

// Email Templates
export const GetEmailTemplates = () => api.get('/api/resumes/email-templates');
export const CreateEmailTemplate = (data: any) => api.create('/api/resumes/email-templates', data);
export const UpdateEmailTemplate = (templateId: any, data: any) => api.put(`/api/resumes/email-templates/${templateId}`, data);
export const DeleteEmailTemplate = (templateId: any) => api.delete(`/api/resumes/email-templates/${templateId}`);

// Interview Feedback
export const AddInterviewFeedback = (resumeId: any, interviewId: any, data: any) => api.create(`/api/resumes/${resumeId}/interviews/${interviewId}/feedback`, data);
export const GetInterviewFeedback = (resumeId: any, interviewId: any) => api.get(`/api/resumes/${resumeId}/interviews/${interviewId}/feedback`);

// Reminders
export const CreateReminder = (resumeId: any, data: any) => api.create(`/api/resumes/${resumeId}/reminders`, data);
export const GetResumeReminders = (resumeId: any) => api.get(`/api/resumes/${resumeId}/reminders`);
export const UpdateReminder = (resumeId: any, reminderId: any, data: any) => api.put(`/api/resumes/${resumeId}/reminders/${reminderId}`, data);
export const DeleteReminder = (resumeId: any, reminderId: any) => api.delete(`/api/resumes/${resumeId}/reminders/${reminderId}`);

// Offer Management
export const CreateOffer = (resumeId: any, data: any) => api.create(`/api/resumes/${resumeId}/offers`, data);
export const GetResumeOffers = (resumeId: any) => api.get(`/api/resumes/${resumeId}/offers`);
export const UpdateOffer = (resumeId: any, offerId: any, data: any) => api.put(`/api/resumes/${resumeId}/offers/${offerId}`, data);
export const DeleteOffer = (resumeId: any, offerId: any) => api.delete(`/api/resumes/${resumeId}/offers/${offerId}`);

// Analytics
export const GetResumeAnalytics = (filters?: any) => api.get('/api/resumes/analytics', filters);

// Google Integration
export const SendGoogleValidationEmail = (data: any) => api.create('/api/google/auth/send-validation', data);
export const VerifyGoogleValidationCode = (data: any) => api.create('/api/google/auth/verify-code', data);
export const GetGoogleAuthUrl = (email: string) => api.get(`/api/google/auth/url?email=${email}`);
export const HandleGoogleCallback = (data: any) => api.create('/api/google/auth/callback', data);
export const GetGoogleCredentials = () => api.get('/api/google/credentials');
export const DisconnectGoogleAccount = () => api.delete('/api/google/credentials');
export const CreateCalendarEvent = (data: any) => api.create('/api/google/calendar/events', data);
export const GetCalendarEvents = (startDate: string, endDate: string) => api.get(`/api/google/calendar/events?start_date=${startDate}&end_date=${endDate}`);
export const SendGmail = (data: any) => api.create('/api/google/gmail/send', data);
export const ScheduleInterviewWithGoogle = (data: any) => api.create('/api/google/interview/schedule', data);

// Employee / User
export const GetAllEmployees = () => api.get('/api/users/');
export const GetAllEmployeesWithoutRestrictions = () => api.get('/api/users/all');
export const GetEmployeesWithFilters = (filters: any) => {
    const params = new URLSearchParams();
    // Default to Active status if not specified - only return Active employees
    const status = filters.status || 'Active';
    params.append('status', status);
    if (filters.role) params.append('role', filters.role);
    if (filters.gender) params.append('gender', filters.gender);
    if (filters.search) params.append('search', filters.search);
    const queryString = params.toString();
    return api.get(`/api/users/filtered${queryString ? `?${queryString}` : ''}`);
};
export const GetActiveEmployees = () => api.get('/api/users/active');
export const GetActiveEmployeesWithDepartments = (params?: { page?: number; per_page?: number }) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.per_page) queryParams.append('per_page', params.per_page.toString());
    const queryString = queryParams.toString();
    return api.get(`/api/users/active-with-departments${queryString ? `?${queryString}` : ''}`);
};
export const GetEmployeeByID = (user_id: any) => api.get(`/api/users/getByID/${user_id}`);
export const GetEmployeeDetailsByID = (user_id: any) => api.get(`/api/users/getByID/${user_id}`);
export const AddNewEmployee = (data: any) => api.create(`/api/users/auth/registration`, data);
export const UpdateEmployee = (id: any, data: any) => api.put(`/api/users/${id}`, data);
export const UpdateEmployeeProfilePicture = (employee_id: any, data: any) => api.create(`/api/users/${employee_id}/profile-picture`, data);
export const DeleteEmployee = (id: any) => api.delete(`/api/users/${id}`);
export const CheckExistingUser = (params: any) => {
    return api.get('/api/users/checkExists', { params });
};

export const GetBirthday = () => api.get('/api/users/birthdays/today');

// Employee Documents
export const GetAllEmployeeDocuments = (employee_id: any) => api.get(`/api/users/${employee_id}/documents`);
export const AddNewEmployeeDocument = (employee_id: any, data: any) => api.create(`/api/users/${employee_id}/documents`, data);
export const DeleteDocument = (document_id: any) => api.delete(`/api/users/${document_id}/documents`);
export const GetAllEmployeeDevices = (employee_id: any) => api.get(`/api/users/${employee_id}/devices`);
export const GetSalaryHistory = (employee_id: any) => api.get(`/api/users/${employee_id}/salary-history`);
export const AddSalaryHistory = (employee_id: any, data: any) => api.create(`/api/users/${employee_id}/salary-history`, data);

// Profile completeness & AI Insights
export const GetProfileCompleteness = (employee_id: string) => api.get(`/api/users/${employee_id}/profile-completeness`);
export const GetEmployeeInsights = (employee_id: string) => api.get(`/api/users/${employee_id}/insights`);

// Employee Lifecycle History (creation source, resume conversion, intern→employee, profile completed)
export const GetLifecycleHistory = (user_id: string) => api.get(`/api/users/${user_id}/lifecycle-history`);
export const GetLifecycleFlowTemplate = () => api.get('/api/users/lifecycle-flow-template');
export const AddLifecycleEvent = (user_id: string, data: { event_type?: string; occurred_at?: string; metadata?: Record<string, unknown>; label_override?: string }) =>
  api.create(`/api/users/${user_id}/lifecycle-events`, data);
export const UpdateLifecycleEvent = (event_id: string, data: { occurred_at?: string; label_override?: string }) =>
  api.put(`/api/users/lifecycle-events/${event_id}`, data);
export const UpdateLifecycleFlowTemplateItem = (item_id: string, data: { label?: string; description?: string; display_order?: number }) =>
  api.put(`/api/users/lifecycle-flow-template/${item_id}`, data);
export const AddLifecycleFlowTemplateItem = (data: { event_type: string; label: string; description?: string; display_order?: number }) =>
  api.create('/api/users/lifecycle-flow-template', data);
export const DeleteLifecycleFlowTemplateItem = (item_id: string) => api.delete(`/api/users/lifecycle-flow-template/${item_id}`);

// Attendance
export const GetAllAttendance = (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    const queryString = params.toString();
    return api.get(`/api/attendance/${queryString ? `?${queryString}` : ''}`);
};
export const GetAllUsersAttendance = (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    const queryString = params.toString();
    return api.get(`/api/attendance/all-users${queryString ? `?${queryString}` : ''}`);
};
export const GetLeavesForAttendance = (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    const queryString = params.toString();
    return api.get(`/api/attendance/leaves${queryString ? `?${queryString}` : ''}`);
};
export const GetAllEmployeeAttendance = () => api.get(`/api/attendance/employee/getAll`);
export const GetEmployeeAttendanceByDate = (employee_id: any, date: string) => api.get(`/api/attendance/employee/${employee_id}/date/${date}`);
// Employee month/year-specific attendance (current user only)
export const GetEmployeeAttendanceByMonth = (employee_id: string, month: number, year: number) => {
    // Use API client's params handling to match other helpers and ensure consistent headers
    return api.get(`/api/attendance/employee/${employee_id}`, { month, year });
};

// Employee attendance by date range (for export)
export const GetEmployeeAttendanceByDateRange = (employee_id: string, start_date: string, end_date: string) => {
    const params = new URLSearchParams({ start_date, end_date });
    return api.get(`/api/attendance/employee/${employee_id}/range?${params.toString()}`);
};

// Holidays
export const GetAllHolidays = (year?: number, month?: number, status?: string) => {
    const params = new URLSearchParams();
    // Always pass current year if no year specified to ensure we get only current year data
    if (year !== undefined) {
        params.append('year', year.toString());
    } else {
        // Default to current year
        params.append('year', new Date().getFullYear().toString());
    }
    if (month) params.append('month', month.toString());
    if (status) params.append('status', status);
    const queryString = params.toString();
    return api.get(`/api/holidays/${queryString ? `?${queryString}` : ''}`);
};
export const GetHolidayByDate = (date: string) => api.get(`/api/holidays/date/${date}`);
export const GetHolidayById = (id: string) => api.get(`/api/holidays/${id}`);
export const CreateHoliday = (data: any) => api.create(`/api/holidays/`, data);
export const UpdateHoliday = (id: string, data: any) => api.put(`/api/holidays/${id}`, data);
export const DeleteHoliday = (id: string) => api.delete(`/api/holidays/${id}`);
export const AddNewCheckIn = (data: any) => api.create(`/api/attendance/check-in`, data);
export const AddNewCheckOut = (id: any, data: any) => api.put(`/api/attendance/check-out`, data);

// Traditional Attendance Management
export const CreateCheckIn = (data: any) => api.create(`/api/attendance/check-in`, data);
export const CreateCheckOut = (data: any) => api.put(`/api/attendance/check-out`, data);
export const GetTodaysAttendance = () => api.get(`/api/attendance/today`);
export const ApproveOvertime = (attendance_id: string, data: any) => api.put(`/api/attendance/overtime/approve/${attendance_id}`, data);

// Attendance Approval Management
export const GetPendingAttendanceApprovals = () => api.get('/api/attendance/approvals/pending');
export const GetApprovedAttendanceApprovals = () => api.get('/api/attendance/approvals/approved');
export const GetRejectedAttendanceApprovals = () => api.get('/api/attendance/approvals/rejected');
export const GetAttendanceApprovalStatistics = () => api.get('/api/attendance/approvals/stats');
export const HandleApprovalAction = (approvalId: string, data: any) => api.put(`/api/attendance/approvals/${approvalId}/action`, data);
export const GetMyPendingApprovals = () => api.get('/api/attendance/approvals/my-pending');
// Combined approvals endpoint – replaces 3 separate calls with one
export const GetAllAttendanceApprovals = (status?: string) =>
    api.get(`/api/attendance/approvals/all${status ? `?status=${status}` : ''}`);

// Attendance insights (streaks, on-time count, trend)
export const GetAttendanceInsights = () => api.get('/api/attendance/insights');

// Attendance correction requests (self-service)
export const GetMyCorrectionRequests = () => api.get('/api/attendance/corrections');
export const CreateCorrectionRequest = (data: {
  correction_type: string;
  reason: string;
  attendance_id?: string;
  requested_date?: string;
  requested_check_in?: string;
  requested_check_out?: string;
}) => api.create('/api/attendance/corrections', data);

// Sales Attendance
export const GetAllSalesData = () => api.get(`/api/attendance/sales/`);
export const GetAllUsersWithSalesData = () => api.get(`/api/attendance/sales/all-users`);

// Crashlytics
export const GetAllCrashlyticsErrors = (filters?: any) => {
    const params = new URLSearchParams();
    if (filters?.error_type) params.append('error_type', filters.error_type);
    if (filters?.severity) params.append('severity', filters.severity);
    if (filters && filters.resolved !== null && filters.resolved !== undefined) params.append('resolved', filters.resolved.toString());
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());
    return api.get(`/api/crashlytics/errors?${params.toString()}`);
};
export const CreateCrashlyticsError = (data: any) => api.create(`/api/crashlytics/errors`, data);
export const UpdateCrashlyticsError = (id: any, data: any) => api.put(`/api/crashlytics/errors/${id}`, data);
export const DeleteCrashlyticsError = (id: any) => api.delete(`/api/crashlytics/errors/${id}`);
export const ExportCrashlyticsErrors = (filters?: any) => {
    const params = new URLSearchParams();
    if (filters?.error_type) params.append('error_type', filters.error_type);
    if (filters?.severity) params.append('severity', filters.severity);
    if (filters && filters.resolved !== null && filters.resolved !== undefined) params.append('resolved', filters.resolved.toString());
    return api.get(`/api/crashlytics/export?${params.toString()}`);
};
export const GetTravelPathData = (userId: string, date?: string) => api.get(`/api/attendance/sales/travel-path/${userId}${date ? `?date=${date}` : ''}`);

// Tickets
export const GetAllTickets = () => api.get('/api/ticket/');
export const GetTicketByID = (ticketId: string) => api.get(`/api/ticket/${ticketId}`);
export const GetTicketsByEmployeeID = (employeeId: string) => api.get(`/api/ticket/employee/${employeeId}`);
export const GetMyCreatedTickets = () => api.get('/api/ticket/my-created');
export const GetAssignedTickets = () => api.get('/api/ticket/assigned');
export const CreateTicket = (data: any) => api.create('/api/ticket/', data);
export const UpdateTicket = (ticketId: string, data: any) => api.put(`/api/ticket/${ticketId}`, data);
export const DeleteTicket = (ticketId: string) => api.delete(`/api/ticket/${ticketId}`);
export const AddTicketComment = (ticketId: string, data: any) => api.create(`/api/ticket/${ticketId}/comments`, data);
export const DeleteTicketComment = (ticketId: string, commentId: string) => api.delete(`/api/ticket/${ticketId}/comments/${commentId}`);
export const GetTicketStats = () => api.get('/api/ticket/stats');
export const EscalateTicket = (ticketId: string, data: any) => api.create(`/api/ticket/${ticketId}/escalate`, data);
export const UploadTicketAttachment = (ticketId: string, formData: FormData) => api.create(`/api/ticket/${ticketId}/attachments`, formData);
export const DownloadTicketAttachment = (ticketId: string, attachmentId: string) => api.get(`/api/ticket/${ticketId}/attachments/${attachmentId}`);
export const DeleteTicketAttachment = (ticketId: string, attachmentId: string) => api.delete(`/api/ticket/${ticketId}/attachments/${attachmentId}`);

// Comment Attachment Methods
export const DownloadCommentAttachment = (ticketId: string, commentId: string, attachmentId: string) => api.get(`/api/ticket/${ticketId}/comments/${commentId}/attachments/${attachmentId}`);
export const DeleteCommentAttachment = (ticketId: string, commentId: string, attachmentId: string) => api.delete(`/api/ticket/${ticketId}/comments/${commentId}/attachments/${attachmentId}`);
export const GetUserRoutes = (userId: string, startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    
    return api.get(`/api/attendance/sales/user-trips/${userId}?${params.toString()}`);
};

// Geofence Management
export const GetAllGeofences = () => api.get('/api/geofence/');
export const GetGeofenceByID = (geofence_id: string) => api.get(`/api/geofence/${geofence_id}`);
export const CreateGeofence = (data: any) => api.create('/api/geofence/', data);
export const UpdateGeofence = (geofence_id: string, data: any) => api.put(`/api/geofence/${geofence_id}`, data);
export const DeleteGeofence = (geofence_id: string) => api.delete(`/api/geofence/${geofence_id}`);
export const ValidateLocation = (data: any) => api.create('/api/geofence/validate-location', data);
export const GetGeofenceLogs = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.employee_id) queryParams.append('employee_id', params.employee_id);
    if (params?.geofence_id) queryParams.append('geofence_id', params.geofence_id);
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    return api.get(`/api/geofence/logs?${queryParams.toString()}`);
};
export const LogGeofenceEvent = (data: any) => api.create('/api/geofence/logs', data);



export const StartSalesDay = (data: any) => api.create(`/api/attendance/sales/day/start`, data);
export const PauseSalesDay = (data: any) => api.create(`/api/attendance/sales/day/pause`, data);
export const ResumeSalesDay = (data: any) => api.create(`/api/attendance/sales/day/resume`, data);
export const CheckoutSalesDay = (data: any) => api.put(`/api/attendance/sales/day/end`, data);

export const SalesVisitCheckIn = (data: any) => api.create(`/api/attendance/sales/visit/check-in`, data);
export const SalesVisitCheckOut = (data: any) => api.put(`/api/attendance/sales/visit/check-out`, data);

export const GetAllSalesLogs = () => api.get(`/api/attendance/sales/logs`);
export const GetSalesLogsByEmployee = (visit_id: string) => api.get(`/api/attendance/sales/logs/${visit_id}`);
export const DeleteSalesLog = (log_id: string) => api.delete(`/api/attendance/sales/logs/${log_id}`);

// Leaves
export const GetAllLeaveTypes = () => api.get(`/api/leaveRequest/types`);
export const GetApplicableLeaveTypes = () => api.get(`/api/leaveRequest/types/applicable`);
export const CreateLeaveType = (data: any) => api.create(`/api/leaveRequest/types`, data);
export const UpdateLeaveType = (id: any, data: any) => api.put(`/api/leaveRequest/types/${id}`, data);
export const DeleteLeaveType = (leave_type_id: string) => api.delete(`/api/leaveRequest/types/${leave_type_id}`);

export const GetRaisedLeaveRequestsByEmployee = () => api.get(`/api/leaveRequest/employee/getByID`);

export const GetAllEmployeeLeaves = () => api.get(`/api/leaveRequest/`);
export const GetOnlyMyLeaves = () => api.get(`/api/leaveRequest/balances/getByEmployeeID`);
export const ApplyForLeave = (data: any) => api.create(`/api/leaveRequest/`, data);
export const LeaveApprovals = (id: any, data: any) => api.put(`/api/leaveRequest/${id}/status`, data);
export const GetLeaveRequestsForApprover = () => api.get(`/api/leaveRequest/approver/pending`);
export const GetDashboardPendingLeaves = () => api.get(`/api/leaveRequest/dashboard/pending`);
export const DeleteLeaveRequest = (leave_request_id: string) => api.delete(`/api/leaveRequest/${leave_request_id}`);
export const WithdrawLeaveRequest = (leave_request_id: string) => api.put(`/api/leaveRequest/${leave_request_id}/withdraw`, {});

// Expense Management
export const GetMyExpenses = () => api.get(`/api/expenses/my-requests`);
export const GetAllExpenses = () => api.get(`/api/expenses/`);
export const ApplyForExpense = (data: any) => api.create(`/api/expenses/`, data);
export const ExpenseApprovals = (id: any, data: any) => api.put(`/api/expenses/${id}/status`, data);
export const GetExpensesForApprover = () => api.get(`/api/expenses/approver/pending`);
export const GetExpenseByID = (expense_id: string) => api.get(`/api/expenses/${expense_id}`);
export const UpdateExpense = (expense_id: string, data: any) => api.put(`/api/expenses/${expense_id}`, data);
export const DeleteExpense = (expense_id: string) => api.delete(`/api/expenses/${expense_id}`);
export const SubmitExpensesForApproval = (data: any) => api.create(`/api/expenses/submit-cycle`, data);
export const MarkExpenseAsPaid = (expense_id: string, data: any) => api.put(`/api/expenses/${expense_id}/mark-paid`, data);

// Outstation Trip Management
export const GetApprovedTrips = () => api.get(`/api/outstation-trips/approved/my-trips`);
export const GetAllTrips = () => api.get(`/api/outstation-trips/my-trips`);
export const GetTripByID = (trip_id: string) => api.get(`/api/outstation-trips/${trip_id}`);
export const CreateTrip = (data: any) => api.create(`/api/outstation-trips/`, data);
export const UpdateTrip = (trip_id: string, data: any) => api.put(`/api/outstation-trips/${trip_id}`, data);
export const DeleteTrip = (trip_id: string) => api.delete(`/api/trips/${trip_id}`);
export const SubmitTripForApproval = (trip_id: string) => api.create(`/api/trips/${trip_id}/submit`, {});
export const UpdateTripStatus = (trip_id: string, data: any) => api.put(`/api/trips/${trip_id}/status`, data);
export const GetPendingTripsForApprover = () => api.get(`/api/trips/approver/pending`);

// Leave Balance Management
export const GetAllLeaveBalances = () => api.get(`/api/leave-balances/`);
export const GetLeaveBalancesByEmployee = (employeeId: string) => api.get(`/api/leave-balances/employee/${employeeId}`);
export const CreateLeaveBalance = (data: any) => api.create(`/api/leave-balances/`, data);
export const CreateAutomaticLeaveBalances = (employeeId: string, data?: any) => api.create(`/api/leave-balances/auto-create/${employeeId}`, data);
export const UpdateLeaveBalance = (balanceId: string, data: any) => api.put(`/api/leave-balances/${balanceId}`, data);
export const DeleteLeaveBalance = (balanceId: string) => api.delete(`/api/leave-balances/${balanceId}`);

// Daily Updates
export const GetAllUpdates = () => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    return api.get(`/api/dailyStatus/all?month=${month}&year=${year}`);
};
export const GetAttendanceStatus = () => api.get(`/api/dailyStatus/employee/attendance/status`);
export const GetOverallUpdates = (month: any,year: any) => api.get(`/api/dailyStatus/all?month=${month}&year=${year}`);
export const GetMonthlyUpdates = (user_name: any,month: any,year: any) => api.get(`/api/dailyStatus/employee?month=${month}&year=${year}`);
export const AddNewDailyUpdate = (data: any) => api.create(`/api/dailyStatus/`, data);

// AI Summary APIs
export const GetWeeklyAISummary = (weekStart?: string, weekEnd?: string) => {
    const params = new URLSearchParams();
    if (weekStart) params.append('week_start', weekStart);
    if (weekEnd) params.append('week_end', weekEnd);
    return api.get(`/api/dailyStatus/ai/weekly-summary?${params.toString()}`);
};

export const GetMonthlyAISummary = (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    const url = `/api/dailyStatus/ai/monthly-summary?${params.toString()}`;
    return api.get(url);
};

export const GetOverallAISummary = (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    const url = `/api/dailyStatus/ai/overall-summary?${params.toString()}`;
    return api.get(url);
};

// Gamification APIs
export const GetGamificationStats = (user_name?: string) => {
    const params = new URLSearchParams();
    if (user_name) params.append('user_name', user_name);
    return api.get(`/api/dailyStatus/gamification/stats${params.toString() ? `?${params.toString()}` : ''}`);
};

export const UpdateGamificationStats = (data: any) => api.put(`/api/dailyStatus/gamification/stats`, data);

export const GetGamificationBadges = (user_name?: string) => {
    const params = new URLSearchParams();
    if (user_name) params.append('user_name', user_name);
    return api.get(`/api/dailyStatus/gamification/badges${params.toString() ? `?${params.toString()}` : ''}`);
};

export const RecordDailyUpdatePoints = (data: any) => api.create(`/api/dailyStatus/gamification/record-points`, data);

// Gamification leaderboard (Star of the Month)
// Expected backend route in our_dashboard:
// GET /api/dailyStatus/gamification/leaderboard?month=MM&year=YYYY&limit=3
export const GetGamificationLeaderboard = (month?: number, year?: number, limit: number = 3) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    if (limit) params.append('limit', limit.toString());
    const query = params.toString();
    return api.get(`/api/dailyStatus/gamification/leaderboard${query ? `?${query}` : ''}`);
};

// Star of the Month (backend-stored; Super Admin sets, visibility controlled)
export const GetStarOfMonth = (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    const query = params.toString();
    return api.get(`/api/dailyStatus/gamification/star-of-month${query ? `?${query}` : ''}`);
};
export const SetStarOfMonth = (data: { month: number; year: number; employee_id: string; visible: boolean }) =>
    api.put('/api/dailyStatus/gamification/star-of-month', data);
export const GetStarOfMonthHistory = (limit: number = 24) =>
    api.get(`/api/dailyStatus/gamification/star-of-month/history?limit=${limit}`);

// Projects
export const GetAllProjects = () => api.get(`/api/projects/`);
export const GetAllProjectsList = () => api.get(`/api/projects/all`);
export const CreateNewProject = (data: any) => api.create(`/api/projects/`, data);
export const UpdateProject = (id: any, data: any) => api.put(`/api/projects/${id}`, data);
export const GetProjectByID = (id: any) => api.get(`/api/projects/${id}`);
export const AssignprojectMember = (project_id: any, data: any) => api.create(`/api/projects/${project_id}/members`, data);

// Project Tasks
export const GetProjectTasks = (id: any) => api.get(`/api/projects/${id}/tasks`);
export const CreateNewTask = (data: any) => api.create(`/api/tasks`, data);
export const UpdateTask = (id: any, data: any) => api.put(`/api/tasks/${id}`, data);
export const DeleteTask = (id: any) => api.delete(`/api/tasks/${id}`);
// Tasks - current user context
export const GetMyTasks = () => api.get(`/api/tasks/my-tasks`);

// Payroll
export const GetAllSalaryEmployees = () => api.get('/api/users/eligible-for-salary');
export const GetSalaryPaidReport = (pay_month?: string, pay_year?: string) => {
  const params: Record<string, string> = {};
  if (pay_month) params.pay_month = pay_month;
  if (pay_year) params.pay_year = pay_year;
  return api.get('/api/payroll/report', params);
};
export const GetByPayrollID = (id: any) => api.get(`/api/payroll/${id}`);
export const GetEmployeeSalarySlips = (id: any) => api.get(`/api/payroll/employee/${id}`);
export const GetPreviousMonthPayroll = (employee_id: string, pay_month?: number, pay_year?: number) => {
  const params = pay_month != null && pay_year != null ? { pay_month, pay_year } : {};
  const query = new URLSearchParams(params as Record<string, string>).toString();
  return api.get(`/api/payroll/employee/${employee_id}/previous-month${query ? `?${query}` : ''}`);
};
export const GetSalaryFormulas = () => api.get(`/api/payroll/salary-formulas`);
export const UpdateSalaryFormulas = (data: any) => api.put(`/api/payroll/salary-formulas`, data);
export const CreateSalarySlip = (data: any) => api.create(`/api/payroll/addNew`, data);
export const GenerateAndReleaseSalaryForAll = (data: any) => api.create(`/api/payroll/generate-bulk`, data);
export const UpdateSalaryRelease = (id: any, data: any) => api.put(`/api/payroll/release/${id}`, data);
export const DeleteSalarySlip = (id: any) => api.delete(`/api/payroll/${id}`);
export const BulkUploadSalarySlips = (employee_id: any, data: any) => api.create(`/api/payroll/bulk-upload/${employee_id}`, data);
export const DownloadSalaryFormat = () => api.get(`/api/payroll/download-format`);
export const SendPayslipLinkEmail = (payroll_id: string) => api.create(`/api/payroll/send-payslip-link/${payroll_id}`, {});

// Employee Assets (HRMS)
export const GetAllEmployeeAssets = () => api.get(`/api/employee-assets/`);
export const GetEmployeeAssetByID = (id: any) => api.get(`/api/employee-assets/${id}`);
export const CreateNewEmployeeAsset = (data: any) => api.create(`/api/employee-assets/`, data);
export const AssignEmployeeAssetToEmployee = (id: any, data: any) => {
    return api.create(`/api/employee-assets/${id}/assign`, data);
};
export const UpdateEmployeeAsset = (id: any, data: any) => api.put(`/api/employee-assets/${id}`, data);
export const ReturnEmployeeAsset = (id: any, data: any) => api.create(`/api/employee-assets/${id}/return`, data);
export const DeleteEmployeeAsset = (id: any) => {
    // DeleteEmployeeAsset API called
    return api.delete(`/api/employee-assets/${id}`);
};

// General Assets (CRM) - keeping for backward compatibility
export const GetAllAssets = () => api.get(`/api/crm/assets/`);
export const GetAssetByID = (id: any) => api.get(`/api/crm/assets/${id}`);
export const CreateNewAsset = (data: any) => api.create(`/api/crm/assets/`, data);
export const AssignAssetToEmployee = (id: any, data: any) => {
    return api.create(`/api/crm/assets/${id}/assign`, data);
};
export const UpdateAsset = (id: any, data: any) => api.put(`/api/crm/assets/${id}`, data);
export const DeleteAsset = (id: any) => api.delete(`/api/crm/assets/${id}`);

// Employee Asset Transfer (HRMS)
export const InitiateEmployeeAssetTransfer = (data: any) => api.create(`/api/employee-assets/transfer/initiate`, data);
export const ConfirmEmployeeAssetTransfer = (transferId: any, data: any) => api.put(`/api/employee-assets/transfer/${transferId}/confirm`, data);
export const RejectEmployeeAssetTransfer = (transferId: any, data: any) => api.put(`/api/employee-assets/transfer/${transferId}/reject`, data);
export const GetEmployeeAssetTransferHistory = (assetId: any) => api.get(`/api/employee-assets/${assetId}/transfers`);
export const GetEmployeeAssetHistory = (assetId: any) => api.get(`/api/employee-assets/${assetId}/history`);
export const GetPendingEmployeeTransfers = () => api.get(`/api/employee-assets/transfers/pending`);
export const GetMyEmployeeTransfers = () => api.get(`/api/employee-assets/transfers/my`);
export const DeleteEmployeeAssetTransfer = (transferId: any) => api.delete(`/api/employee-assets/transfer/${transferId}`);

// Employee Assets (filtered by employee)
export const GetEmployeeAssets = (employeeId: any) => api.get(`/api/employee-assets/?assigned_to=${employeeId}`);
export const GetEmployeeAssetAssignments = (employeeId: any) => api.get(`/api/employee-assets/?assigned_to=${employeeId}`);

// General Asset Transfer (CRM) - keeping for backward compatibility
export const InitiateAssetTransfer = (data: any) => api.create(`/api/crm/assets/transfer/initiate`, data);
export const ConfirmAssetTransfer = (transferId: any, data: any) => api.put(`/api/crm/assets/transfer/${transferId}/confirm`, data);
export const RejectAssetTransfer = (transferId: any, data: any) => api.put(`/api/crm/assets/transfer/${transferId}/reject`, data);
export const GetAssetTransferHistory = (assetId: any) => api.get(`/api/crm/assets/${assetId}/transfers`);
export const GetAssetHistory = (assetId: any) => api.get(`/api/crm/assets/${assetId}/history`);
export const GetPendingTransfers = () => api.get(`/api/crm/assets/transfers/pending`);
export const GetMyTransfers = () => api.get(`/api/crm/assets/transfers/my`);

// Employee Exit Management
export const GetAllEmployeeExits = (employee_id?: string, exit_status?: string, exit_type?: string) => {
    const params = new URLSearchParams();
    if (employee_id) params.append('employee_id', employee_id);
    if (exit_status) params.append('exit_status', exit_status);
    if (exit_type) params.append('exit_type', exit_type);
    const queryString = params.toString();
    return api.get(`/api/employee-exits/${queryString ? `?${queryString}` : ''}`);
};
export const GetEmployeeExitByID = (exit_id: any) => api.get(`/api/employee-exits/${exit_id}`);
export const CreateEmployeeExit = (data: any) => api.create(`/api/employee-exits/`, data);
export const UpdateEmployeeExit = (exit_id: any, data: any) => api.put(`/api/employee-exits/${exit_id}`, data);
export const ApproveEmployeeExit = (exit_id: any, data: any) => api.create(`/api/employee-exits/${exit_id}/approve`, data);
export const ConductExitInterview = (exit_id: any, data: any) => api.create(`/api/employee-exits/${exit_id}/exit-interview`, data);
export const UpdateFinalSettlement = (exit_id: any, data: any) => api.put(`/api/employee-exits/${exit_id}/final-settlement`, data);
export const DeactivateEmployeeAccount = (exit_id: any) => api.create(`/api/employee-exits/${exit_id}/deactivate-account`, {});
export const CompleteEmployeeExit = (exit_id: any) => api.create(`/api/employee-exits/${exit_id}/complete`, {});
export const AddExitChecklistItem = (exit_id: any, data: any) => api.create(`/api/employee-exits/${exit_id}/checklist`, data);
export const UpdateExitChecklistItem = (checklist_id: any, data: any) => api.put(`/api/employee-exits/checklist/${checklist_id}`, data);
export const DeleteExitChecklistItem = (checklist_id: any) => api.delete(`/api/employee-exits/checklist/${checklist_id}`);
export const GetEmployeeAssetsForExit = (employee_id: any) => api.get(`/api/employee-exits/${employee_id}/assets`);

// Employee Loans
export const GetAllLoans = () => api.get(`/api/loans/`);
export const CreateNewLoan = (data: any) => api.create(`/api/loans/`, data);
export const GetEmployeeLoans = (employeeId: any) => api.get(`/api/loans/?employee_id=${employeeId}`);
export const GetPendingLoans = () => api.get(`/api/loans/pending`);
export const GetCompanyLoanInterestRate = (companyId: string) => api.get(`/api/loans/interest-rate/${companyId}`);
export const UpdateLoan = (id: any, data: any) => api.put(`/api/loans/${id}`, data);
export const DeleteLoan = (id: any) => api.delete(`/api/loans/${id}`);
export const ApproveLoan = (id: any, data: any) => api.create(`/api/loans/${id}/approve`, data);
export const RejectLoan = (id: any, data: any) => api.create(`/api/loans/${id}/reject`, data);
export const RecordLoanPayment = (id: any, data: any) => api.create(`/api/loans/${id}/payment`, data);
export const PauseLoanMonth = (id: any, data: any) => api.create(`/api/loans/${id}/pause`, data);
export const ResumeLoanMonth = (id: any, data: any) => api.create(`/api/loans/${id}/resume`, data);
export const GetLoanEMISchedule = (id: any) => api.get(`/api/loans/${id}/emi-schedule`);
export const GetEmployeeActiveLoans = (employeeId: string) => api.get(`/api/payroll/employee/${employeeId}/active-loans`);

// Petty Cash - New System
export const CreatePettyCashFundRequest = (data: any) => api.create(`/api/petty-cash/fund-requests`, data);
export const GetPettyCashFundRequests = (filters?: any) => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.requester_id) params.append('requester_id', filters.requester_id);
    if (filters?.reporting_manager_id) params.append('reporting_manager_id', filters.reporting_manager_id);
    const queryString = params.toString();
    return api.get(`/api/petty-cash/fund-requests${queryString ? `?${queryString}` : ''}`);
};
export const ApprovePettyCashFundRequest = (request_id: string, data: any) => api.put(`/api/petty-cash/fund-requests/${request_id}/approve`, data);
export const RejectPettyCashFundRequest = (request_id: string, data: any) => api.put(`/api/petty-cash/fund-requests/${request_id}/reject`, data);

export const GetPettyCashActiveFund = () => api.get(`/api/petty-cash/funds/active`);
export const ClosePettyCashFund = (fund_id: string, data: any) => api.put(`/api/petty-cash/funds/${fund_id}/close`, data);
export const GetPettyCashFundHistory = () => api.get(`/api/petty-cash/funds/history`);

export const CreatePettyCashExpense = (data: any) => api.create(`/api/petty-cash/expenses`, data);
export const GetPettyCashExpenses = (filters?: any) => {
    const params = new URLSearchParams();
    if (filters?.fund_id) params.append('fund_id', filters.fund_id);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    if (filters?.voucher_type_id) params.append('voucher_type_id', filters.voucher_type_id);
    if (filters?.vendor_id) params.append('vendor_id', filters.vendor_id);
    if (filters?.branch_id) params.append('branch_id', filters.branch_id);
    if (filters?.expense_type_id) params.append('expense_type_id', filters.expense_type_id);
    if (filters?.budget_code_id) params.append('budget_code_id', filters.budget_code_id);
    const queryString = params.toString();
    return api.get(`/api/petty-cash/expenses${queryString ? `?${queryString}` : ''}`);
};

export const GetPettyCashVoucherTypes = () => api.get(`/api/petty-cash/catalog/voucher-types`);
export const CreatePettyCashVoucherType = (data: any) => api.create(`/api/petty-cash/catalog/voucher-types`, data);
export const DeletePettyCashVoucherType = (id: string) => api.delete(`/api/petty-cash/catalog/voucher-types/${id}`);

export const GetPettyCashVendors = () => api.get(`/api/petty-cash/catalog/vendors`);
export const CreatePettyCashVendor = (data: any) => api.create(`/api/petty-cash/catalog/vendors`, data);
export const DeletePettyCashVendor = (id: string) => api.delete(`/api/petty-cash/catalog/vendors/${id}`);

export const GetPettyCashBranches = () => api.get(`/api/petty-cash/catalog/branches`);
export const CreatePettyCashBranch = (data: any) => api.create(`/api/petty-cash/catalog/branches`, data);
export const DeletePettyCashBranch = (id: string) => api.delete(`/api/petty-cash/catalog/branches/${id}`);

export const GetPettyCashExpenseTypes = () => api.get(`/api/petty-cash/catalog/expense-types`);
export const CreatePettyCashExpenseType = (data: any) => api.create(`/api/petty-cash/catalog/expense-types`, data);
export const DeletePettyCashExpenseType = (id: string) => api.delete(`/api/petty-cash/catalog/expense-types/${id}`);

export const GetPettyCashBudgetCodes = () => api.get(`/api/petty-cash/catalog/budget-codes`);
export const CreatePettyCashBudgetCode = (data: any) => api.create(`/api/petty-cash/catalog/budget-codes`, data);
export const DeletePettyCashBudgetCode = (id: string) => api.delete(`/api/petty-cash/catalog/budget-codes/${id}`);

export const GetPettyCashReports = (filters?: any) => {
    const params = new URLSearchParams();
    if (filters?.fund_id) params.append('fund_id', filters.fund_id);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    if (filters?.manager_id) params.append('manager_id', filters.manager_id);
    if (filters?.voucher_type_id) params.append('voucher_type_id', filters.voucher_type_id);
    if (filters?.vendor_id) params.append('vendor_id', filters.vendor_id);
    const queryString = params.toString();
    return api.get(`/api/petty-cash/reports${queryString ? `?${queryString}` : ''}`);
};

export const GetPettyCashEmployees = () => api.get(`/api/petty-cash/employees`);



// Contact Form
export const GetAllContactFormData = () => api.get(`/api/contact/`);
export const DeleteContactForm = (id: any) => api.delete(`/api/contact/${id}`);

// Notifications
export const GetAllNotifications = () => api.get(`/api/notifications/`);
export const MarkAsRead = (id: any, data: any) => api.put(`/api/notifications/${id}/mark-read`, data);
export const CreateNotificationForAll = (data: any) => api.create(`/api/notifications/add-for-all`, data);
export const CreateNotificationForUser = (data: any) => api.create(`/api/notifications/add`, data);
export const CreateNotificationForGroup = (data: any) => api.create(`/api/notifications/add-for-group`, data);
export const DeleteNotification = (id: any) => api.delete(`/api/notifications/${id}`);
export const BulkDeleteNotifications = (ids: string[]) => api.delete(`/api/notifications/bulk-delete`, { data: { ids } });
export const VerifyUserStatus = () => api.get(`/api/notifications/verify-status`);

// Calendar
export const getEvents = () => api.get(`/api/events/`);
export const createEvent = (data: any) => api.create(`/api/events/`, data);
export const updateEvent = (id: any, data: any) => api.put(`/api/events/${id}`, data);
export const deleteEvent = (id: any) => api.delete(`/api/events/${id}`);
export const deleteEventsByUser = (userId: any) => api.delete(`/api/events/user/${userId}`);

// Calls
export const createCall = (data: any) => api.create(`/api/calls`, data);
export const updateCall = (id: any, data: any) => api.put(`/api/calls/${id}`, data);
export const getCallHistory = (userId: any, params?: any) => api.get(`/api/calls/history/${userId}`, params);
export const getCallById = (id: any) => api.get(`/api/calls/${id}`);
export const deleteCall = (id: any) => api.delete(`/api/calls/${id}`);

// Engage APIs
export const GetEngagePosts = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());
    if (params?.search) queryParams.append('search', params.search);
    return api.get(`/api/engage/posts?${queryParams.toString()}`);
};

export const CreateEngagePost = (data: any) => api.create(`/api/engage/posts`, data);
export const UpdateEngagePost = (id: any, data: any) => api.put(`/api/engage/posts/${id}`, data);
export const DeleteEngagePost = (id: any) => api.delete(`/api/engage/posts/${id}`);
export const AddPostReaction = (data: any) => api.create(`/api/engage/reactions`, data);
export const AddPostComment = (data: any) => api.create(`/api/engage/comments`, data);
export const DeletePostComment = (id: any) => api.delete(`/api/engage/comments/${id}`);

// Feedback
export const GetAllFeedback = () => api.get(`/api/feedback/`);
export const CreateFeedback = (data: any) => api.create(`/api/feedback/`, data);
export const GetFeedbackByID = (id: any) => api.get(`/api/feedback/${id}`);
export const UpdateFeedback = (id: any, data: any) => api.put(`/api/feedback/${id}`, data);
export const DeleteFeedback = (id: any) => api.delete(`/api/feedback/${id}`);
export const GetFeedbackByEmployee = (employeeId: any) => api.get(`/api/feedback/employee/${employeeId}`);

// Notes
export const GetAllNotes = () => api.get(`/api/notes/`);
export const GetDraftNotes = () => api.get(`/api/notes/drafts`);
export const CreateNote = (data: any) => api.create(`/api/notes/`, data);
export const SaveDraft = (data: any) => api.create(`/api/notes/draft`, data);
export const GetNoteByID = (id: any) => api.get(`/api/notes/${id}`);
export const UpdateNote = (id: any, data: any) => api.put(`/api/notes/${id}`, data);
export const DeleteNote = (id: any) => api.delete(`/api/notes/${id}`);

// Notes History APIs
export const GetNoteHistory = (noteId: string, limit?: number) => {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    return api.get(`/api/notes/${noteId}/history?${params.toString()}`);
};
export const GetUserNotesHistory = (limit?: number) => {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    return api.get(`/api/notes/history?${params.toString()}`);
};
export const GetCompanyNotesHistory = (limit?: number) => {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    return api.get(`/api/notes/history/company?${params.toString()}`);
};

// Email Management
export const SendEmployeeEmail = (data: any) => api.create(`/api/users/send-employee-email`, data);

// Password Management
export const AdminResetPassword = (data: any) => api.create(`/api/users/reset-password`, data);
export const AdminChangeUserStatus = (data: any) => api.put(`/api/users/admin/change-status`, data);
export const SendEmailVerification = () => api.create(`/api/users/send-email-verification`, {});
export const AdminSendEmailVerification = (data: any) => api.create(`/api/users/admin/send-email-verification`, data);
export const AdminMarkEmailVerified = (data: { target_user_id: string }) => api.create(`/api/users/admin/mark-email-verified`, data);
export const VerifyEmailToken = (token: string) => api.get(`/api/users/verify-email?token=${token}`);
export const GetEmailLogs = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.days) queryParams.append('days', params.days.toString());
    if (params?.status) queryParams.append('status', params.status);
    if (params?.recipient) queryParams.append('recipient', params.recipient);
    const queryString = queryParams.toString();
    return api.get(`/api/logs/email-logs${queryString ? `?${queryString}` : ''}`);
};

// Sender Email Management
export const GetAllSenderEmails = () => api.get('/api/sender-emails/');
export const GetSenderEmailByID = (id: any) => api.get(`/api/sender-emails/${id}`);
export const CreateSenderEmail = (data: any) => api.create('/api/sender-emails/', data);
export const UpdateSenderEmail = (id: any, data: any) => api.put(`/api/sender-emails/${id}`, data);
export const DeleteSenderEmail = (id: any) => api.delete(`/api/sender-emails/${id}`);
export const GetDefaultSenderEmail = () => api.get('/api/sender-emails/default');
export const SetDefaultSenderEmail = (id: any) => api.put(`/api/sender-emails/${id}/set-default`, {});

// Visits
export const GetAllVisits = () => api.get('/api/visits/');
export const GetMyVisits = () => api.get('/api/visits/my-visits');
export const GetVisitByID = (id: any) => api.get(`/api/visits/${id}`);
export const AddNewVisit = (data: any) => api.create(`/api/visits/`, data);
export const UpdateVisit = (id: any, data: any) => api.put(`/api/visits/${id}`, data);
export const DeleteVisit = (id: any) => api.delete(`/api/visits/${id}`);

// Visit Notes
export const GetAllVisitNotes = (id: any) => api.get(`/api/visits/${id}/notes`);
export const AddNewVisitNote = (id: any, data: any) => api.create(`/api/visits/${id}/notes`, data);
export const UpdateVisitNote = (id: any, data: any) => api.put(`/api/visits/notes/${id}`, data);
export const DeleteVisitNote = (id: any) => api.delete(`/api/visits/notes/${id}`);

// Facial Recognition APIs
export const GetFacialRecognitionStatus = (userId: string) => api.get(`/api/facial-recognition/status/${userId}`);
export const RegisterFace = (data: any) => api.create(`/api/facial-recognition/register`, data);
export const RegisterFaceForUser = (userId: string, data: any) => api.create(`/api/facial-recognition/register/${userId}`, data);
export const VerifyFace = (data: any) => api.create(`/api/facial-recognition/verify`, data);
export const DeleteFaceEncoding = () => api.delete(`/api/facial-recognition/delete`);
export const DeleteFaceEncodingForUser = (userId: string) => api.delete(`/api/facial-recognition/delete/${userId}`);
export const EnableFacialRecognition = (userId: string, data: any) => api.put(`/api/facial-recognition/enable/${userId}`, data);
export const DisableFacialRecognition = (userId: string) => api.put(`/api/facial-recognition/disable/${userId}`, {});
export const BulkEnableFacialRecognition = (data: any) => api.create(`/api/facial-recognition/bulk-enable`, data);
export const BulkDisableFacialRecognition = (data: any) => api.create(`/api/facial-recognition/bulk-disable`, data);

// Simplified Facial Recognition APIs
export const SimpleRegisterFace = (data: any) => api.create(`/api/facial-recognition/simple-register`, data);
export const SimpleVerifyFace = (data: any) => api.create(`/api/facial-recognition/simple-verify`, data);
export const FaceCheckIn = (data: any) => api.create(`/api/facial-recognition/check-in`, data);

// Facial Recognition Approval APIs
export const GetPendingApprovals = () => api.get(`/api/facial-recognition/approvals/pending`);
export const GetApprovalStatistics = () => api.get(`/api/facial-recognition/approvals/statistics`);
export const ApproveFaceRegistration = (approvalId: string) => api.create(`/api/facial-recognition/approvals/${approvalId}/approve`, {});
export const RejectFaceRegistration = (approvalId: string, reason: string) => api.create(`/api/facial-recognition/approvals/${approvalId}/reject`, { reason });
export const DeleteFaceRegistration = (approvalId: string) => api.delete(`/api/facial-recognition/approvals/${approvalId}`);
export const SubmitFaceRegistration = (data: any) => api.create(`/api/facial-recognition/submit`, data);

// Dashboard Menu Permissions (separate from CRM)
export const GetDashboardUserMenuPermissions = (cacheBust?: boolean) => {
    const timestamp = cacheBust ? `?t=${Date.now()}` : '';
    return api.get(`/api/dashboard/menu-permissions/user/menus${timestamp}`);
};
export const GetAllDashboardMenuPermissions = () => api.get('/api/dashboard/menu-permissions/menus');
export const CreateDashboardMenuPermission = (data: any) => api.create('/api/dashboard/menu-permissions/menus', data);
export const UpdateDashboardMenuPermission = (id: string, data: any) => api.put(`/api/dashboard/menu-permissions/menus/${id}`, data);
export const DeleteDashboardMenuPermission = (id: string) => api.delete(`/api/dashboard/menu-permissions/menus/${id}`);

// Dashboard User Module Assignments (separate from CRM)
export const GetDashboardUserModuleAssignments = (user_id: string) => api.get(`/api/dashboard/menu-permissions/user-modules/user/${user_id}`);
export const AssignDashboardModulesToUser = (data: any) => api.create('/api/dashboard/menu-permissions/user-modules/assign', data);
export const RemoveDashboardModulesFromUser = (data: any) => api.create('/api/dashboard/menu-permissions/user-modules/remove', data);
export const GetAllDashboardUserModuleAssignments = () => api.get('/api/dashboard/menu-permissions/user-modules/all');
export const GetDashboardUsersByModule = (menu_permission_id: string) => api.get(`/api/dashboard/menu-permissions/user-modules/module/${menu_permission_id}/users`);
export const BulkAssignDashboardModules = (data: any) => api.create('/api/dashboard/menu-permissions/user-modules/bulk-assign', data);
export const EnsureDashboardForAllUsers = () => api.create('/api/dashboard/menu-permissions/user-modules/ensure-dashboard', {});

// QR Code Generator
export const GetDashboardQRCodes = (params?: { limit?: number; include_inactive?: boolean }) => {
    const queryParams = new URLSearchParams();
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.include_inactive) queryParams.append('include_inactive', 'true');
    const queryString = queryParams.toString();
    return api.get(`/api/dashboard/qr-codes${queryString ? `?${queryString}` : ''}`);
};
export const CreateDashboardQRCode = (data: any) => api.create('/api/dashboard/qr-codes', data);
export const UpdateDashboardQRCode = (id: string, data: any) => api.put(`/api/dashboard/qr-codes/${id}`, data);
export const DeleteDashboardQRCode = (id: string) => api.delete(`/api/dashboard/qr-codes/${id}`);

// PDF to CSV (Super Admin tool)
export const ConvertPdfToCsv = async (formData: FormData): Promise<Blob> => {
    /**
     * NOTE:
     * Our axios interceptor in `api_helper.ts` returns `response.data` by default,
     * so this call typically resolves to a Blob directly (not an AxiosResponse).
     * This wrapper normalizes the result to a Blob in case interceptors/config change.
     */
    // Ensure Authorization header is set (this API call bypasses APIClient.setAuthHeader()).
    let token: string | null = null;
    try {
        const authUser = localStorage.getItem("authUser");
        token = authUser ? JSON.parse(authUser) : null;
        if (token) setAuthorization(token);
    } catch {
        token = null;
    }

    const res: any = await axios.post(
        '/api/pdf-to-csv/convert',
        formData,
        {
            responseType: 'blob',
            headers: token ? { Authorization: `Bearer ${token}` } : undefined
        }
    );

    if (res instanceof Blob) return res;
    if (res?.data instanceof Blob) return res.data;

    // Last-resort fallback: wrap whatever we got into a blob so downloads still work.
    return new Blob([res], { type: 'text/csv;charset=utf-8' });
};

// Menu Permissions (keeping original for backward compatibility)
export const GetUserMenuPermissions = () => api.get('/api/menu-permissions/user/menus');
export const GetAllMenuPermissions = () => api.get('/api/menu-permissions/menus');
export const CreateMenuPermission = (data: any) => api.create('/api/menu-permissions/menus', data);
export const UpdateMenuPermission = (id: string, data: any) => api.put(`/api/menu-permissions/menus/${id}`, data);
export const DeleteMenuPermission = (id: string) => api.delete(`/api/menu-permissions/menus/${id}`);

// User Module Assignments (keeping original for backward compatibility)
export const GetUserModuleAssignments = (user_id: string) => api.get(`/api/user-modules/user/${user_id}`);
export const AssignModulesToUser = (data: any) => api.create('/api/user-modules/assign', data);
export const RemoveModulesFromUser = (data: any) => api.create('/api/user-modules/remove', data);
export const GetAllUserModuleAssignments = () => api.get('/api/user-modules/all');
export const GetUsersByModule = (menu_permission_id: string) => api.get(`/api/user-modules/module/${menu_permission_id}/users`);
export const BulkAssignModules = (data: any) => api.create('/api/user-modules/bulk-assign', data);

// Performance Review APIs
export const GetAllPerformanceReviews = () => api.get('/api/performance-reviews/');
export const GetPerformanceReviewById = (reviewId: string) => api.get(`/api/performance-reviews/${reviewId}`);
export const GetMyPerformanceReviews = () => api.get('/api/performance-reviews/my-reviews');
export const GetManagerPerformanceReviews = () => api.get('/api/performance-reviews/manager-reviews');
export const CreatePerformanceReview = (data: any) => api.create('/api/performance-reviews/', data);
export const UpdatePerformanceReview = (id: string, data: any) => api.put(`/api/performance-reviews/${id}`, data);
export const DeletePerformanceReview = (id: string) => api.delete(`/api/performance-reviews/${id}`);

// Review Cycles
export const GetAllReviewCycles = () => api.get('/api/review-cycles/');
export const GetReviewCycleById = (cycleId: string) => api.get(`/api/review-cycles/${cycleId}`);
export const CreateReviewCycle = (data: any) => api.create('/api/review-cycles/', data);
export const UpdateReviewCycle = (id: string, data: any) => api.put(`/api/review-cycles/${id}`, data);
export const DeleteReviewCycle = (id: string) => api.delete(`/api/review-cycles/${id}`);

// Review Templates
export const GetAllReviewTemplates = () => api.get('/api/review-templates/');
export const GetReviewTemplateById = (templateId: string) => api.get(`/api/review-templates/${templateId}`);
export const CreateReviewTemplate = (data: any) => api.create('/api/review-templates/', data);
export const UpdateReviewTemplate = (id: string, data: any) => api.put(`/api/review-templates/${id}`, data);
export const DeleteReviewTemplate = (id: string) => api.delete(`/api/review-templates/${id}`);

// Review Submissions
export const SubmitSelfReview = (reviewId: string, data: any) => api.create(`/api/performance-reviews/${reviewId}/self-review`, data);
export const SubmitManagerReview = (reviewId: string, data: any) => api.create(`/api/performance-reviews/${reviewId}/manager-review`, data);
export const SubmitHRReview = (reviewId: string, data: any) => api.create(`/api/performance-reviews/${reviewId}/hr-review`, data);
export const AcknowledgeReview = (reviewId: string) => api.create(`/api/performance-reviews/${reviewId}/acknowledge`, {});

// Admin Review APIs
export const GetAdminPerformanceReviews = () => api.get('/api/performance-reviews/admin-reviews');
export const RequestReviewRevision = (reviewId: string, data: any) => api.create(`/api/performance-reviews/${reviewId}/request-revision`, data);
export const GetReviewHistory = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    if (params?.employee_id) queryParams.append('employee_id', params.employee_id);
    if (params?.cycle_id) queryParams.append('cycle_id', params.cycle_id);
    if (params?.status) queryParams.append('status', params.status);
    const queryString = queryParams.toString();
    return api.get(`/api/performance-reviews/history${queryString ? `?${queryString}` : ''}`);
};
export const GetReviewStatistics = () => api.get('/api/performance-reviews/statistics');

// Weekly Learning Submission APIs
export const GetAllWeeklyLearningSubmissions = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.year) queryParams.append('year', params.year.toString());
    if (params?.week_number) queryParams.append('week_number', params.week_number.toString());
    if (params?.employee_id) queryParams.append('employee_id', params.employee_id);
    const queryString = queryParams.toString();
    return api.get(`/api/weekly-learning-submissions${queryString ? `?${queryString}` : ''}`);
};
export const GetMyWeeklyLearningSubmissions = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.year) queryParams.append('year', params.year.toString());
    if (params?.week_number) queryParams.append('week_number', params.week_number.toString());
    const queryString = queryParams.toString();
    return api.get(`/api/weekly-learning-submissions/my-submissions${queryString ? `?${queryString}` : ''}`);
};
export const GetCurrentWeekSubmission = () => api.get('/api/weekly-learning-submissions/current-week');
export const GetWeeklyLearningSubmissionById = (submissionId: string) => api.get(`/api/weekly-learning-submissions/${submissionId}`);
export const CreateWeeklyLearningSubmission = (data: any) => api.create('/api/weekly-learning-submissions/', data);
export const UpdateWeeklyLearningSubmission = (id: string, data: any) => api.put(`/api/weekly-learning-submissions/${id}`, data);
export const DeleteWeeklyLearningSubmission = (id: string) => api.delete(`/api/weekly-learning-submissions/${id}`);

// Time Tracking APIs
export const StartTimer = (data: any) => api.create(`/api/time-tracking/start`, data);
export const StopTimer = (data: any) => api.put(`/api/time-tracking/stop`, data);
export const GetActiveTimer = () => api.get(`/api/time-tracking/active`);
export const GetTimeEntries = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    if (params?.project_id) queryParams.append('project_id', params.project_id);
    if (params?.task_id) queryParams.append('task_id', params.task_id);
    if (params?.status) queryParams.append('status', params.status);
    const queryString = queryParams.toString();
    return api.get(`/api/time-tracking/entries${queryString ? `?${queryString}` : ''}`);
};
export const GetTimeSummary = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    const queryString = queryParams.toString();
    return api.get(`/api/time-tracking/summary${queryString ? `?${queryString}` : ''}`);
};
export const UpdateTimeEntry = (timeTrackingId: string, data: any) => api.put(`/api/time-tracking/${timeTrackingId}`, data);
export const DeleteTimeEntry = (timeTrackingId: string) => api.delete(`/api/time-tracking/${timeTrackingId}`);

// Timesheet APIs
export const CreateTimesheet = (data: any) => api.create(`/api/timesheets/`, data);
export const GetTimesheets = (params?: any) => {
    const queryParams = new URLSearchParams();
    if (params?.employee_id) queryParams.append('employee_id', params.employee_id);
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    if (params?.status) queryParams.append('status', params.status);
    const queryString = queryParams.toString();
    return api.get(`/api/timesheets/${queryString ? `?${queryString}` : ''}`);
};
export const GetTimesheetById = (timesheetId: string) => api.get(`/api/timesheets/${timesheetId}`);
export const SubmitTimesheet = (timesheetId: string) => api.put(`/api/timesheets/${timesheetId}/submit`, {});
export const ApproveTimesheet = (timesheetId: string, data: any) => api.put(`/api/timesheets/${timesheetId}/approve`, data);
export const RejectTimesheet = (timesheetId: string, data: any) => api.put(`/api/timesheets/${timesheetId}/reject`, data);

// Elasticsearch Search
export const ElasticsearchSearch = (data: { query: string; type?: string; limit?: number }) => {
    const params = new URLSearchParams();
    params.append('query', data.query);
    if (data.type) params.append('type', data.type);
    if (data.limit) params.append('limit', data.limit.toString());
    return api.get(`/api/search/elasticsearch?${params.toString()}`);
};

// AI Assistant APIs
export const SendAIMessage = (data: { question: string; session_id?: string }) => 
    api.create('/api/ai/ask', data);

export const StartAISession = () => 
    api.create('/api/ai/session/start', {});

export const EndAISession = (sessionId: string) => 
    api.create(`/api/ai/session/${sessionId}/end`, {});

export const GetAIConversationHistory = (limit: number = 10) => 
    api.get(`/api/ai/history?limit=${limit}`);

export const SubmitAIFeedback = (data: { conversation_id: string; was_helpful: boolean; feedback?: string; rating?: number }) => 
    api.create('/api/ai/feedback', data);